<template>
  <div :class="{ content: fromPage == 'apply', vipcontent: fromPage == 'vip' }">
    <div :class="{ bodycontent: fromPage == 'apply' }" v-loading="loading">
      <el-form :model="formData" ref="formData" label-width="180px">
        <el-form-item label="店铺" v-if="multi">
          <!-- <el-select v-model="formData.store_id" placeholder="请选择商户" class="input_box">
            <el-option
              v-for="item in store_list"
              :key="item.id"
              :label="item.merch_name"
              :value="item.id">
            </el-option>
          </el-select> -->
          <div v-if="if_add">
            <div>
              <el-cascader
                :options="store_options"
                v-model="store_id"
                expand-trigger="hover"
                class="input_box"
                :disabled="checked"
              >
              </el-cascader>
            </div>
            <el-checkbox v-model="checked">平台自营店铺</el-checkbox>
          </div>
          <span v-else>{{ this.store_name }}</span>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-input v-model="formData.name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="门店照片">
          <!-- <el-upload
            class="avatar-uploader"
            action="https://www.58zltc.com/api/Upload/uploads/"
            :show-file-list="false"
            accept="image/*"
            :data="imgdata"
            :before-upload="upBefore"
            :on-success="handleAvatarSuccess">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload> -->
          <el-upload
            list-type="picture-card"
            accept="image/*"
            action="#"
            :limit="9"
            :http-request="
              (file) => {
                return productUploadImg(file);
              }
            "
            :on-remove="(file) => handleRemove(file)"
            :before-upload="beforeLogoUpload"
            :file-list="fakefileList1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="注册所在地">
          <el-cascader
            :options="options"
            v-model="area_id"
            expand-trigger="hover"
            class="input_box"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input
            type="textarea"
            rows="2"
            v-model="formData.address"
            class="input_box"
          ></el-input>
        </el-form-item>
        <el-form-item label="位置定位">
          经度：<el-input
            readonly
            class="point_box"
            v-model="mapPoint.lng"
          ></el-input>
          纬度：<el-input
            readonly
            class="point_box"
            v-model="mapPoint.lat"
          ></el-input>
          <el-button @click="showmap = true">选择坐标</el-button>
        </el-form-item>
        <el-form-item label="门店标签">
          <el-tag
            v-for="(tag, index) in tagsList"
            :key="index"
            closable
            @close="delTagItem(index)"
            style="margin-right: 5px"
          >
            {{ tag }}
          </el-tag>
          <el-button type="primary" @click="newTag" size="small"
            >新增</el-button
          >
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="formData.mobile" class="input_box"></el-input>
        </el-form-item>
        <!-- <el-form-item label="营业时间">
          <el-time-picker
            class="input_box_small"
            arrow-control
            v-model="start_time"
            value-format="yyyy-M-d HH:mm:ss"
            placeholder="开始时间"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59'
            }"
          >
          </el-time-picker>
          <span style="margin:0 12px">至</span>
          <el-time-picker
            class="input_box_small"
            arrow-control
            v-model="end_time"
            value-format="yyyy-M-d HH:mm:ss"
            placeholder="结束时间"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59'
            }"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item label="是否停业">
          <el-radio-group v-model="formData.rest">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="submit" :loading="uploadLoading"
          >提交</el-button
        >
        <el-button @click="goback()">返回列表</el-button>
      </div>
    </div>
    <!-- 地图选择 -->
    <el-dialog :visible.sync="showmap" @close="closeMap">
      <div class="map_search">
        <el-input v-model="mapKeyword">
          <template slot="append">
            <el-button @click="searchMap">搜索</el-button>
          </template>
        </el-input>
      </div>
      <!-- <Map @getPoint="getpoint" ref="Bmap"></Map> -->
      <BMap @getPoint="getpoint" ref="Bmap"></BMap>
      <div class="map_button">
        <span>经度：{{ mapPoint.lng }}</span>
        <span>纬度：{{ mapPoint.lat }}</span>
        <div>
          <el-button @click="closeMap()">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增标签 -->
    <el-dialog
      :visible.sync="showAddTag"
      @close="closeAddTag"
      width="400px"
      title="新增标签"
    >
      <el-input v-model="tagName">
        <template slot="append">
          <el-button @click="saveAddTag">保存</el-button>
        </template>
      </el-input>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// import Map from "@/components/map/tmap";
import BMap from "@/components/map/bmap";
import { areajson } from "@/components/public/area";
import { storeAdd, storeEdit, allStore, storeDetail } from "@/api/storeManage";
import { addImage } from "@/api/mall";
export default {
  props: {
    fromPage: {
      type: String,
      default: "apply",
    },
  },
  components: {
    // Map,
    BMap
  },
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      formData: {},
      store_options: [], //店铺选项
      store_id: [], //选择的店铺选项
      store_name: "", //编辑时显示店铺名
      options: areajson, //所在地
      area_id: [],
      start_time: "2020-1-1 08:30:00",
      end_time: "2020-1-1 18:00:00",
      imageUrl: "", //上传的图片地址
      imgdata: {}, //上传图片附加信息
      image_id: "", //上传后服务器路径
      uploadLoading: false, //上传时loading
      if_add: true, //是否是新增
      loading: false, //页面loading
      multi: false, //是否是多商户 多商户需选择商户
      store_list: [], //商户列表
      checked: false, //平台自营店铺
      showmap: false, //显示地图
      mapPoint: {},
      mapKeyword: "", //地图关键字搜索
      tagsList: [], //标签
      showAddTag: false, //显示新增标签
      tagName: "", //新增标签内容
      chosepictireid1: [], //已上传图片id数组暂存
      fakefileList1: [], //假的filelist列表
      fileListData1: [], //filelist列表
    };
  },
  methods: {
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    init() {
      this.loading = true;
      allStore({ token: this.token, app_id: this.app_id }).then((res) => {
        if (res.code == 200) {
          this.multi = true;
          var list = res.data;
          list.forEach((item) => {
            var idata = {
              value: item.id,
              label: item.merch_name,
              children: [],
            };
            if (item.store.length == 0) {
              idata.disabled = true;
            } else {
              item.store.forEach((n) => {
                var sdata = {
                  value: n.id,
                  label: n.title,
                };
                idata.children.push(sdata);
              });
            }
            this.store_options.push(idata);
          });
          console.log(this.store_options);
        } else if (res.code == 400) {
          this.multi = false;
        } else {
          this.$message(res.msg);
        }
        this.loading = false;
        this.initForm();
      });
    },
    initForm() {
      this.imgdata = {
        token: this.token,
        type: "1",
        file_group: "1",
      };
      if (this.$route.query.sid) {
        this.if_add = false;
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: this.$route.query.sid,
        };
        storeDetail(data).then((res) => {
          if (res.code == 200) {
            var editForm = Object.assign({}, res.data);
            console.log(editForm);
            this.start_time = "2020-1-1 " + editForm.start_time;
            this.end_time = "2020-1-1 " + editForm.end_time;
            this.store_name = editForm.store_name;
            this.image_id = editForm.image_id;
            var areaId = editForm.area_id.toString().split("");
            var areaId0 = areaId[0] + areaId[1] + "0000";
            var areaId1 = areaId[0] + areaId[1] + areaId[2] + areaId[3] + "00";
            this.area_id = [areaId0, areaId1, editForm.area_id.toString()];
            this.tagsList = editForm.tag;
            this.mapPoint = {
              lat: editForm.lat,
              lng: editForm.lng,
            };
            // 圖片列表
            editForm.image.forEach((item) => {
              let obj = {
                url: item,
                uid: editForm.image_id,
              };
              this.fakefileList1.push(obj);
            });
            delete editForm.create_time;
            delete editForm.update_time;
            delete editForm.image;
            delete editForm.store_name;
            delete editForm.merch_name;
            this.formData = Object.assign({}, editForm);
          }
        });
      } else {
        this.formData = {
          rest: 0,
        };
      }
    },
    submit() {
      // if (this.imageUrl != "") {
      this.save();
      // }else{
      //   this.$message({
      //     type:"error",
      //     message: "请上传门店图片"
      //   })
      // }
    },
    // 图片上传
    // 上传之前
    upBefore(file) {
      console.log(file);
      this.imgdata.image = file;
      this.imageUrl = URL.createObjectURL(file);
      console.log(this.imgdata);
      this.uploadLoading = true;
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.image_id = res.data.id;
      this.uploadLoading = false;
    },
    //保存表单
    save() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var data = Object.assign({}, this.formData);
      data.image_id = this.image_id;
      data.token = this.token;
      data.app_id = this.app_id;
      let areaLength = this.area_id.length||0
      data.area_id = this.area_id[areaLength>0?this.area_id.length-1:areaLength];
      data.start_time = this.start_time.split(" ")[1];
      data.end_time = this.end_time.split(" ")[1];
      data.lat = this.mapPoint.lat;
      data.lng = this.mapPoint.lng;
      var tags = "";
      this.tagsList.forEach((item) => {
        tags += item + ",";
      });
      data.tag = tags.substring(0, tags.length - 1);
      console.log(data);
      if (this.if_add) {
        data.store_id = this.checked ? "0" : this.store_id[1];
        storeAdd(data).then((res) => {
          if (res.code == "200") {
            this.$message({
              type: "success",
              message: res.msg,
            });
            sessionStorage.setItem("newName", data.name);
            loading.close();
            this.goback();
          } else {
            loading.close();
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      } else {
        storeEdit(data).then((res) => {
          if (res.code == "200") {
            loading.close();
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.goback();
          } else {
            loading.close();
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      }
    },
    goback() {
      this.$router.go(-1);
    },
    //关闭地图
    closeMap() {
      this.showmap = false;
    },
    //地图选点
    getpoint(e) {
      console.log(e.lng, e.lat);
      this.mapPoint = e;
    },
    //地图搜索
    searchMap() {
      this.$refs.Bmap.search(this.mapKeyword);
    },
    searchKey() {
      this.$refs.Bmap.getSuggestionsFunc(this.mapKeyword);
    },
    //打开新增标签窗口
    newTag() {
      this.tagName = "";
      this.showAddTag = true;
    },
    // 保存新增标签
    saveAddTag() {
      if (this.tagName) {
        this.tagsList.push(this.tagName);
        this.closeAddTag();
      } else {
        this.$message({
          type: "error",
          message: "请输入标签内容",
        });
      }
    },
    //上传门店图片
    productUploadImg(file) {
      console.log(file);
      var that = this;
      var formdata = new FormData();
      formdata.append("token", that.token);
      formdata.append("image", file.file);
      formdata.append("type", "1");
      formdata.append("file_group", "1");
      addImage(formdata).then((res) => {
        console.log("上传回调", res);
        var data = res.data;
        if (res.code == 200) {
          this.chosepictireid1.push(res.data.id);
          this.image_id = this.chosepictireid1.join(",");
          var list = {};
          list.name = res.data.key;
          list.url = res.data.url;
          list.uid = file.file.uid;
          this.fakefileList1.push(list);
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }
      });
    },
    // 删除门店图片
    handleRemove(file) {
      console.log(file);
      var replaceArr = [];
      replaceArr = this.fakefileList1;
      console.log(replaceArr);
      for (var i = 0; i < replaceArr.length; i++) {
        if (file.uid == replaceArr[i].uid) {
          replaceArr.splice(i, 1);
          this.chosepictireid1.splice(i, 1);
          this.image_id = this.chosepictireid1.join(",");
          console.log(this.formData.images, "delete list1 item");
          break;
        }
      }
    },
    // 关闭新增标签窗口
    closeAddTag() {
      this.showAddTag = false;
    },
    // 删除门店标签
    delTagItem(i) {
      this.tagsList.splice(i, 1);
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    .input_box {
      width: 400px;
    }
    .input_box_small {
      width: 150px;
    }
    .point_box {
      width: 149px;
      margin-right: 15px;
    }
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
    // 图片上传
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
    .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
  }
  .map_search {
    margin-bottom: 10px;
  }
  .map_button {
    height: 40px;
    line-height: 40px;
    margin-top: 20px;
    span {
      margin-right: 20px;
    }
    div {
      float: right;
    }
  }
}
.vipcontent {
  height: 100%;
  padding: 25px 10px;
  overflow: auto;
  .input_box {
    width: 400px;
  }
  .input_box_small {
    width: 150px;
  }
  .point_box {
    width: 149px;
    margin-right: 15px;
  }
  .state_text {
    color: #999;
    font-size: 12px;
    height: 20px;
    line-height: 30px;
  }
  .bottom_btn {
    margin-left: 180px;
    margin-top: 30px;
    .ml30 {
      margin-left: 30px;
    }
  }
  // 图片上传
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
  .map_search {
    margin-bottom: 10px;
  }
  .map_button {
    height: 40px;
    line-height: 40px;
    margin-top: 20px;
    span {
      margin-right: 20px;
    }
    div {
      float: right;
    }
  }
}
</style>
